module.exports = __webpack_public_path__ + "img/176.meat.a421ae07.svg";